module.exports = __webpack_public_path__ + "static/media/cart.c2f05dd1.png";